export const maxPageNumbersToShow = 3;
export const pageSize = 6;